import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=26e36f96"
import script from "./article-card.vue?vue&type=script&lang=js"
export * from "./article-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports